import { ICommon } from "../interface/common";
import { Observable } from "rxjs/Observable";
import { MasterOperationService } from "./../services/master-operation.service";
import { HttpClientService } from "../../../shared/service/http/http-client.service";
import { CookiesService } from "../../../shared/service/cookies/cookies.service";
export class Action extends MasterOperationService implements ICommon {
  public path: string = "";
  public data: any = null;
  public files: any[] = null;
  public header: Array<any>;
  http: HttpClientService;
  constructor(http: HttpClientService, cookies: CookiesService) {
    super(http, cookies);
  }
  save(): Observable<any> {
    if (this.header !== null) {
      super.setHeader(this.header);
    }
    return super.save(this.path, this.data);
  }
  saveDataWithFiles(): Observable<any> {
    return super.saveDataWithFiles(this.path, this.data, this.files);
  }
  update(): Observable<any> {
    super.setHeader(this.header);
    return super.update(this.path, this.data);
  }
  getFile(): Observable<any> {
    super.setHeader(this.header);
    return super.getFile(this.path);
  }
  get(): Observable<any> {
    super.setHeader(this.header);
    return super.get(this.path);
  }
  delete(): Observable<any> {
    super.setHeader(this.header);
    return super.delete(this.path);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/action.ts